// Article #5 — South Florida Pool Finish Comparison.
// The visible FAQ section and the FAQPage schema both read from this single
// array, so they always match exactly.
export const FAQS_POOL_FINISH_COMPARISON: {
  question: string;
  answer: string;
}[] = [
  {
    question: "What is the best pool finish for South Florida?",
    answer:
      "There is no single best finish for every South Florida pool. Traditional plaster, quartz, Diamond Brite, pebble, and specialty finishes offer different combinations of appearance, texture, maintenance expectations, variation, and project cost. The best choice depends on the exact product, pool conditions, design goals, homeowner preferences, installation system, and ongoing care.",
  },
  {
    question: "Is Diamond Brite plaster, quartz, or pebble?",
    answer:
      "Diamond Brite is a branded exposed-aggregate pool finish made with selected quartz aggregates and fortified white Portland cement. It belongs within the broader quartz-finish category, although its exact colors and product specifications should be reviewed individually.",
  },
  {
    question: "Is a pebble pool finish rough?",
    answer:
      "Some exposed-pebble finishes have a noticeably textured surface, while refined, smaller-aggregate, or polished products may feel smoother. \u201cPebble\u201d describes a broad category, so homeowners should touch samples and compare the exact product, particularly when steps, benches, spas, or sun shelves are important.",
  },
  {
    question: "Does a darker pool finish make the water look darker?",
    answer:
      "A darker finish generally contributes to a deeper or darker perceived water color, but it is not the only factor. Pool depth, sunlight, shade, landscaping, deck color, tile, lighting, water movement, chemistry, and reflections can all change how the water appears.",
  },
  {
    question: "Will my finished pool match the color sample exactly?",
    answer:
      "No sample or photograph can guarantee an exact match. Cementitious finishes can show normal variation, and the final water appearance is influenced by depth, lighting, surroundings, water conditions, installation, and curing. Samples should guide the color direction rather than function as an exact promise.",
  },
  {
    question: "Is mottling in a new pool finish always a defect?",
    answer:
      "No. Cementitious pool finishes can naturally show shading, color variation, mottling, or differences in aggregate concentration. However, photographs alone cannot determine whether a specific condition is expected or requires evaluation. Concerns should be reviewed under appropriate conditions by the responsible pool professional.",
  },
  {
    question: "Does a pebble or quartz finish eliminate maintenance concerns?",
    answer:
      "No. Every cementitious pool finish depends on appropriate installation, startup, filtration, cleaning, and balanced water conditions. No finish should be represented as maintenance-free or immune to scale, staining, etching, discoloration, or surface changes.",
  },
  {
    question: "Should I choose the pool finish before the tile and coping?",
    answer:
      "The finish, waterline tile, and coping should be selected as a coordinated palette. The deck, home exterior, landscaping, lighting, and other outdoor materials should also be considered. Choosing each component separately increases the risk that individually attractive materials will compete once installed.",
  },
];

export const TOC_POOL_FINISH_COMPARISON = [
  { id: "the-short-answer", title: "The Short Answer" },
  {
    id: "what-a-pool-finish-actually-does",
    title: "What a Pool Finish Actually Does",
  },
  {
    id: "pool-finish-comparison-at-a-glance",
    title: "Pool Finish Comparison at a Glance",
  },
  {
    id: "traditional-plaster-or-marcite",
    title: "Traditional Plaster or Marcite",
  },
  {
    id: "quartz-and-diamond-brite-finishes",
    title: "Quartz and Diamond Brite Finishes",
  },
  {
    id: "pebble-and-exposed-aggregate-finishes",
    title: "Pebble and Exposed-Aggregate Finishes",
  },
  {
    id: "other-finish-categories-worth-understanding",
    title: "Other Finish Categories Worth Understanding",
  },
  {
    id: "how-finish-choice-changes-water-appearance",
    title: "How Finish Choice Changes Water Appearance",
  },
  {
    id: "texture-and-comfort-underfoot",
    title: "Texture and Comfort Underfoot",
  },
  {
    id: "normal-variation-mottling-and-expectations",
    title: "Normal Variation, Mottling, and Expectations",
  },
  {
    id: "maintenance-startup-and-water-chemistry",
    title: "Maintenance, Startup, and Water Chemistry",
  },
  {
    id: "how-to-choose-the-right-finish-for-your-pool",
    title: "How to Choose the Right Finish for Your Pool",
  },
  { id: "frequently-asked-questions", title: "Frequently Asked Questions" },
];
